function parentsRGBColor(parent = {}, colors = []) {
	const folderColorRGBA = colors.find(color => parent.color===color.id)
	return folderColorRGBA ? folderColorRGBA.color : {r: '184', g: '192', b: '198'}
}

export default parentsRGBColor
